module.exports = __webpack_public_path__ + "static/media/system_a.f5c4b0c6.png";